import { computed, useStore } from '@nuxtjs/composition-api'
import { useDayjs } from '../plugins/dayjs'
import useComp from './useComp'
import useErrorHandler from './useErrorHandler'

export default function useUser(context) {
  const store = useStore()
  const dayjs = useDayjs()

  const { compAdultAge, compVipLevels, compVipLevelsList } = useComp()
  const { responseCodeToMessage } = useErrorHandler(context)

  const adultAge = computed(() => {
    const defaultAge = 18

    return Number(compAdultAge.value || defaultAge)
  })
  const user = computed(() => store.state.authModule.user)
  const token = computed(() => store.state.authModule.token)
  const maskUsername = computed(
    () => user.value?.username?.replace(/^(.{2}).+(.{3})$/, '$1***$2') ?? ''
  )
  const currencySymbol = computed(() =>
    user.value && user.value.userCurrency && user.value.userCurrency === 'JPY'
      ? '¥'
      : '$'
  )
  const thirdPaymentList = computed(() => {
    if (!user.value) return []
    return user.value.thirdPaymentList.filter(t => {
      if (t.hasOwnProperty('withdrawStatus')) {
        return t.withdrawStatus === 1
      }

      return true
    })
  })

  function levelName(level) {
    if (level >= 1000) {
      return context.root.$t(`user.level.${level}`)
    }

    // const userLevel = context.root.$t(`userLevels.${compId.value}.${level}.name`)
    const userLevel = compVipLevels.value.find(vip => vip.lv === level)

    return userLevel ? userLevel.name : ''
  }

  function levelListName(level) {
    if (level >= 1000) {
      return context.root.$t(`user.level.${level}`)
    }

    const userLevel = compVipLevelsList.value.find(vip => vip.lv === level)

    return userLevel ? userLevel.name : ''
  }

  function checkIsAdult(birthday) {
    if (!birthday) {
      return true
    }

    console.log('adultAge', adultAge, typeof adultAge)

    // check birthday for ages
    const birthdayDate = dayjs(birthday, 'YYYY-MM-DD')
    if (dayjs().diff(birthdayDate, 'year') < adultAge.value) {
      context.root.$swal({
        type: 'error',
        title: context.root.$t(
          'component.mixin.mixinErrorHandler.method.errorHandler.other.failOperation'
        ),
        text: responseCodeToMessage('413207', [adultAge.value])
      })

      return false
    }

    return true
  }

  function getThirdPaymentName(thirdPayment) {
    return (
      thirdPayment.thirdName +
      (thirdPayment.virtualCurrency ? `-${thirdPayment.virtualCurrency}` : '')
    )
  }

  function getThirdPaymentType(thirdPayment) {
    return (
      thirdPayment.thirdType +
      (thirdPayment.virtualCurrency ? `-${thirdPayment.virtualCurrency}` : '')
    )
  }

  function getCurrencySymbol(currency) {
    switch (currency) {
      case 'JPY':
        return '¥'
      case 'USD':
        return '$'
    }
  }

  return {
    adultAge,
    user,
    token,
    maskUsername,
    currencySymbol,
    thirdPaymentList,

    levelName,
    levelListName,
    checkIsAdult,
    getThirdPaymentName,
    getThirdPaymentType,
    getCurrencySymbol
  }
}
